import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  userFirstName: null,
  userLastName: null,
  userId: null,
  userAvatar: localStorage.getItem('avatar') || null,
  userEmail: localStorage.getItem('userEmail') || null,
  subscription: localStorage.getItem('subscription') || null,
  parentRef: localStorage.getItem('parentRef') || null,
  expirationDate: localStorage.getItem('expirationDate') || null,
  companyName: localStorage.getItem('companyName') || null,
  jobPosition: localStorage.getItem('jobPosition') || null,
  city: localStorage.getItem('city') || null,
  country: localStorage.getItem('country') || null,
  socialNetwork: localStorage.getItem('socialNetwork') || null,
  locale: localStorage.getItem('locale') || 'en',
  rol: localStorage.getItem('rol') || '',
  telephone: localStorage.getItem('telephone') || '',
  deposit: localStorage.getItem('deposit') || false,
  admissionsComittee: localStorage.getItem('admissionsComittee') || false,
  kycInformation: localStorage.getItem('kycInformation') || false,
  ndaDraft: localStorage.getItem('ndaDraft') || false,
  contractDraft: localStorage.getItem('contractDraft') || false,
  signedNDA: localStorage.getItem('signedNDA') || null,
  admissionDate: localStorage.getItem('admissionDate') || null,
  signedContract: localStorage.getItem('signedContract') || null,
  kyc: localStorage.getItem('kyc') || null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}

